export default "__VITE_ASSET__d2fc112d__"